import { useLocation, type Location } from 'react-router'

export const useTypedLocation = <T>() => {
  return useLocation() as Location<T>
}
